export * from './table/table.component';
export * from './detail/detail.component';
export * from './confirm-dialog/confirm-dialog.component';
export * from './add-button/add-button.component';
export * from './crudbuttons/crudbuttons.component';
export * from './base';



